/**
 * Template for creating new exercises
 */
import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';

const useStyles = makeStyles(theme => ({
  wrapper: {
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    '& > div': {
      maxWidth: 700,
      padding: 30,
      maxHeight: '100%',
      overflow: 'auto',
    },
  },
  sample: {
    color: theme.palette.primary.main,
    backgroundColor: theme.palette.secondary.main,
  },
  action: {
    marginTop: 50,
    textAlign: 'center',
    verticalAlign: 'middle',
    '& button': {
      margin: '0 10px',
      verticalAlign: 'middle',
    },
    '& > span': {
      display: 'inline-block',
      minWidth: 53,
      verticalAlign: 'middle',
      userSelect: 'none',
    },
  },
  '@media(max-width: 850px)': {

  }
}));

function LearnByHeart(props) {
  const classes = useStyles();
  const { exercise, startStats, finishExercise, action, type, close } = props.exerciseProps;
  const [ text, setText ] = useState([]);

  useEffect(() => {
    startStats(type);
    finishExercise();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    const html = exercise.text;
    setText(parseHtml(html));
    // eslint-disable-next-line
  }, [exercise]);

  const parseHtml = (str) => {
    const page = [];
    const el = document.createElement( 'html' );
    el.innerHTML = str;
    el.querySelectorAll('p').forEach(p => {
      const el = { text: '', style: {} };
      el.style.textAlign = 'center';
      // if (p.style.textAlign) el.style.textAlign = p.style.textAlign;
      if (p?.style?.color) el.style.color = p.style.color;
      if (p?.style?.fontWeight) el.style.fontWeight = p.style.fontWeight;
      const rawText = p.innerHTML;
      if (isHtml(rawText)) {
        const div = document.createElement( 'html' );
        div.innerHTML = rawText;
        const span = div.querySelector('span');
        // if (span.style.textAlign) el.style.textAlign = span.style.textAlign;
        if (span?.style?.color) el.style.color = span.style.color;
        if (span?.style?.fontWeight) el.style.fontWeight = span.style.fontWeight;
      }
      el.text = (p.textContent || p.innerText || "").trim();
      page.push(el);
    })
    return page;
  }

  const isHtml = (str) => /<[a-z][\s\S]*>/i.test(str);

  const print = () => {
    action();
    var w = window.open();
    const div = document.createElement( 'div' );
    text.forEach(el => {
      const p = document.createElement( 'p' );
      Object.keys(el.style).forEach(key => {
        p.style[key] = el.style[key];
      });
      p.innerText = el.text;
      div.appendChild(p);
    });
    const html = `<!DOCTYPE html><html lang="en"><head><meta charset="UTF-8"><title>Copyright Instytut Colina Rose Sp. z o.o.</title></head><body style="padding: 2em 1em; font-size: 18px;">${div.innerHTML}</body></html>`;
    w.document.write(html);
    w.print();
    w.close();
  }

  return (
    <div className={classes.wrapper}>
      <Paper elevation={3} >
        <div className={classes.text}>
          {text.map((p, idx) => <p key={idx} style={p.style}>{p.text}</p>)}
        </div>
        <div className={classes.action}>
          <Button variant="outlined" color="primary" onClick={print}>Drukuj</Button>
          <Button variant="outlined" color="secondary" onClick={close}>Zamknij</Button>
        </div>
      </Paper>
    </div>
  );
}

const mapStateToProps = (state) => {
  return { 
    media: state.media,
    mobile: state.mobile,
  }
}

export default connect(mapStateToProps)(LearnByHeart);